<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <a-form-model @keyup.enter.native="handleSearch" layout="inline">
      <a-form-item label="流程名称">
        <a-input placeholder="请输入流程名称" v-model="model.processName" />
      </a-form-item>
      <a-form-item>
        <a-button html-type="submit" type="primary">查询</a-button>
      </a-form-item>
    </a-form-model>
    <div class="list-box mt-20px">
      <div class="list-item mb-20px" v-for="(list,key) in tableData">
        <div class="border-blue-500 h-22px text-base mb-12px pl-6px box-title">{{list[0].classifyName}}</div>
        <div class="grid gap-10 grid-cols-5">
          <div @click="handleCreateOrder(item)" class="h-80px p-8px flex shadow-md c" v-for="(item,key) in list">
            <!-- <img alt class="w-80px" src /> -->
            <div class="w-80px flex justify-center items-center text-3xl">
              <a-icon :type="item.icon" />
            </div>
            <div class="flex flex-1 flex-col pl-8px">
              <span class="flex-1 text-lg" style="color:#1890ff">{{item.name}}</span>
              <span class="h-30px">{{item.remarks}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { httpAction, getAction } from '@/api/manage'
  export default {
    name: 'ApplyOrder',

    components: {

    },
    // 定义属性
    data () {
      return {
        description: '工单申请',
        model: {},
        tableData: []
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      this.getListData()
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {

      getListData () {
        getAction('/workorder/pProcessInfo/list', {
          pageNo: 1,
          pageSize: 200
        }).then(res => {
          const data = this.arrGroup(res.result.records, (item) => item.classifyId)
          if (data.length) {
            this.tableData = data
          }


        }).finally(res => { })

      },
      arrGroup (arr, fn) {
        const keyArr = [...new Set(arr.map(item => fn(item)))];
        return keyArr.map(key => arr.filter(i => i.classifyId === key));
      },
      handleSearch () {

      },
      //跳转创建工单
      handleCreateOrder (item) {
        const { id } = item
        this.$router.push({
          path: '/process/create-ticket', query: {
            processId: id
          }
        })
      }

    }
  }
</script>

<style lang='less' scoped>
  .workflow-classify-title {
    border-left: 3px solid #409eff;
    padding-left: 5px;
  }
  .box-title {
    border-width: 0 0 0 4px;
    border-style: solid;
    border-color: #409eff;
  }
  .c {
    cursor: pointer;
    border: 1px solid #1890ff;
    :hover {
      border-color: red;
    }
  }
</style>